import gql from 'graphql-tag';

const dealerListQuery = gql`
  query customerDealerList(
    $dealer_no: String
    $limit: Int
    $page: Int
    $sort: String
  ) {
    customerDealerList(
      dealer_no: $dealer_no
      limit: $limit
      page: $page
      sort: $sort
    ) {
      customerNumber
      customerName
      customerEmail
      customerPhone
      customerCity
      customerState
      customerZip
      address1
      address2
      customerType
      isRep
      groupId
      groupName
      createdAt
      updatedAt
    }
  }
`;

export default dealerListQuery;
